// extracted by mini-css-extract-plugin
export default {"btn":"linkButton_btn__EITDY","btnSecond":"linkButton_btnSecond__d2T2K"};